module.exports = __webpack_public_path__ + "media/effects-17.328092ee.webm";